/**
 * useTaskStoreConnection — Connect/disconnect the Zustand task store
 *
 * Call this hook once at the app level (inside AuthProvider + project context).
 * It connects the store when projectId + userId are available,
 * and disconnects on unmount or when project changes.
 */

import { useEffect } from 'react';
import { useTaskStore } from '../store/taskStore';

export function useTaskStoreConnection(
  projectId: string | null | undefined,
  userId: string | null | undefined
): void {
  const connect = useTaskStore((s) => s.connect);
  const disconnect = useTaskStore((s) => s.disconnect);

  useEffect(() => {
    if (projectId && userId) {
      connect(projectId, userId);
    }
    return () => {
      disconnect();
    };
  }, [projectId, userId, connect, disconnect]);
}
